import React, { useEffect, useState } from "react";
import Apiservice from "../Apiservice";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { formatDate } from "../Utils/Utils";

const LeaveApplicationList = () => {
    const navigate = useNavigate();
    const [allUsers, setAllUsers] = useState([]);
    const [allSites, setAllSites] = useState([]);
    const [allLeaveCategories, setAllLeaveCategories] = useState([]);
    const [applicationStatus, setApplicationStatus] = useState([
        { id: 1, value: 0, status: 'Applied' },
        { id: 2, value: 1, status: 'Approved' },
        { id: 3, value: 2, status: 'Cancelled' }
    ]);
    //const [applicationStatus, setApplicationStatus] = useState(['Applied', 'Approved', 'Cancelled']);

    const [searchableUserId, setSearchableUserId] = useState(0);
    const [searchableSiteId, setSearchableSiteId] = useState(0);
    const [leaveApplicationStatus, setLeaveApplicationStatus] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");


    const [leaveApplications, setLeaveApplications] = useState([]);
    const [filteredLeaveApplications, setFilteredLeaveApplications] = useState([]);

    const [roleId, setRoleId] = useState(0);

    useEffect(() => {
        const fetchData = async () => {
            let role_id = localStorage.getItem("role_id");
            setRoleId(role_id);
            let data = {
                "status": 0
            }
            let result = await Apiservice.LeaveApplicationListPage(data);
            if (result.success === true) {
                let retrievedData = result.data;
                setAllUsers(retrievedData.allUsers)
                setAllSites(retrievedData.allSites);
                setAllLeaveCategories(retrievedData.leaveCategories)
            }
        };
        fetchData();
    }, [])

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        const userId = localStorage.getItem("user_id");
        const roleId = parseInt(localStorage.getItem("role_id"), 10);

        let data = {};
        if (roleId !== 1) {
            data = { userId: userId, status: 0 };
        } else {
            data = { status: 0 };
        }

        const result = await Apiservice.LeaveGet(data);
        if (result.success === true) {
            setLeaveApplications(result.data);
            setFilteredLeaveApplications(result.data);
        }
    };

    const handleApprove = (id, userId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to approve this leave?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, approve it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const data = { id: id, leaveStatus: 1, userId: userId };
                    const response = await Apiservice.LeaveApproveOrCancel(data);

                    if (response.success === true) {
                        await Swal.fire("Approved!", response.message, "success");

                        // 🔑 Make sure id comparison is type-safe
                        // setLeaveApplications((prev) =>
                        //     prev.map((app) =>
                        //         String(app.id) === String(id)
                        //             ? { ...app, leaveStatus: 1 }
                        //             : app
                        //     )
                        // );
                        setLeaveApplications((prev) => {
                            const updated = prev.map((app) =>
                                String(app.id) === String(id) ? { ...app, leaveStatus: 1 } : app
                            );
                            setFilteredLeaveApplications(updated); // 🔑 keep filtered in sync
                            return updated;
                        });
                    } else {
                        Swal.fire("Error!", response.message, "error");
                    }
                } catch (error) {
                    Swal.fire("Error!", "Something went wrong!", "error");
                    console.error(error);
                }
            }
        });
    };

    const handleCancel = (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to cancel this leave?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, cancel it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const data = { id: id, leaveStatus: 2 };
                    const response = await Apiservice.LeaveApproveOrCancel(data);

                    if (response.success === true) {
                        await Swal.fire("Cancelled!", response.message, "success");

                        // ✅ Update both lists instantly
                        setLeaveApplications((prev) => {
                            const updated = prev.map((app) =>
                                String(app.id) === String(id) ? { ...app, leaveStatus: 2 } : app
                            );
                            setFilteredLeaveApplications(updated); // keep filtered in sync
                            return updated;
                        });
                    } else {
                        Swal.fire("Error!", response.message, "error");
                    }
                } catch (error) {
                    Swal.fire("Error!", "Something went wrong!", "error");
                    console.error(error);
                }
            }
        });
    };

    const handleSearch = () => {


        let filtered = [...leaveApplications]; // always start from original list
        console.log("filered", filtered);
        console.log("searchable User Id", searchableUserId);
        console.log("searchable Application Status", leaveApplicationStatus);

        if (searchableUserId !== 0) {
            filtered = filtered.filter((app) => app.userId == searchableUserId);
        }

        if (searchableSiteId !== 0) {
            filtered = filtered.filter((app) => app.siteId == searchableSiteId);
        }

        if (leaveApplicationStatus !== "") {
            filtered = filtered.filter(
                (app) => String(app.leaveStatus) == String(leaveApplicationStatus)
            );
        }
        if (fromDate !== "" && toDate !== "") {
            filtered = filtered.filter((item) => {
                let details;
                try {
                    details = JSON.parse(item.details);
                } catch (e) {
                    return false;
                }

                if (!Array.isArray(details)) return false;

                const searchFrom = new Date(fromDate).toISOString().split("T")[0];
                const searchTo = new Date(toDate).toISOString().split("T")[0];

                return details.some((d) => {
                    const detailFrom = new Date(d.fromDate).toISOString().split("T")[0];
                    const detailTo = new Date(d.toDate).toISOString().split("T")[0];

                    // check overlap with range
                    return (
                        (detailFrom >= searchFrom && detailFrom <= searchTo) ||
                        (detailTo >= searchFrom && detailTo <= searchTo) ||
                        (detailFrom <= searchFrom && detailTo >= searchTo)
                    );
                });
            });
        }





        setFilteredLeaveApplications(filtered);
    };

    const handleReset = async () => {
        setSearchableUserId(0);
        setSearchableSiteId(0);
        setLeaveApplicationStatus("");
        setFromDate("");
        setToDate("")
        setFilteredLeaveApplications(leaveApplications)
    }


    const handleApplyLeave = async () => {
        navigate('/leaveform')
    }

    // Function to render status with badges
    const renderStatus = (status) => {
        if (status === 0)
            return <span className="badge bg-warning text-dark">Applied</span>;
        if (status === 1)
            return <span className="badge bg-success">Approved</span>;
        return <span className="badge bg-danger">Cancelled</span>;
    };



    let serial = 1;

    return (
        <div className="container mt-1">
            {
                roleId == 1 && (
                    <div className="row mb-5"
                        style={{
                            position: window.innerWidth >= 768 ? "sticky" : "static",
                            top: window.innerWidth >= 768 ? "60px" : "auto",
                            zIndex: window.innerWidth >= 768 ? 1000 : "auto",
                        }}
                    >
                        <div
                            className="card border-0 shadow-sm mb-3"
                            style={{

                                borderRadius: "12px",
                                background: "#fff",
                            }}
                        >
                            <div
                                className="card-header bg-primary text-white py-2"
                                style={{
                                    borderTopLeftRadius: "12px",
                                    borderTopRightRadius: "12px",
                                }}
                            >
                                <h6 className="mb-0 fw-bold">
                                    Leave Application Filters
                                </h6>
                            </div>

                            <div className="card-body">
                                <div className="row g-3">

                                    {/* Staff */}
                                    <div className="col-md-3">
                                        <label className="form-label fw-semibold">
                                            Staff
                                        </label>
                                        <select
                                            className="form-select form-select-sm"
                                            value={searchableUserId}
                                            onChange={(e) =>
                                                setSearchableUserId(e.target.value)
                                            }
                                        >
                                            <option value="">Select Staff</option>
                                            {allUsers.map((user) => (
                                                <option
                                                    key={user.id}
                                                    value={user.id}
                                                >
                                                    {user.firstName} {user.lastName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* Site */}
                                    <div className="col-md-3">
                                        <label className="form-label fw-semibold">
                                            Site
                                        </label>
                                        <select
                                            className="form-select form-select-sm"
                                            value={searchableSiteId}
                                            onChange={(e) =>
                                                setSearchableSiteId(e.target.value)
                                            }
                                        >
                                            <option value="">Select Site</option>
                                            {allSites.map((site) => (
                                                <option
                                                    key={site.id}
                                                    value={site.id}
                                                >
                                                    {site.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* Status */}
                                    <div className="col-md-2">
                                        <label className="form-label fw-semibold">
                                            Status
                                        </label>
                                        <select
                                            className="form-select form-select-sm"
                                            value={leaveApplicationStatus}
                                            onChange={(e) =>
                                                setLeaveApplicationStatus(
                                                    e.target.value
                                                )
                                            }
                                        >
                                            <option value="">
                                                Select Status
                                            </option>
                                            {applicationStatus.map((status) => (
                                                <option
                                                    key={status.id}
                                                    value={status.value}
                                                >
                                                    {status.status}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* From Date */}
                                    <div className="col-md-2">
                                        <label className="form-label fw-semibold">
                                            From Date
                                        </label>
                                        <input
                                            type="date"
                                            className="form-control form-control-sm"
                                            value={fromDate}
                                            onChange={(e) =>
                                                setFromDate(e.target.value)
                                            }
                                        />
                                    </div>

                                    {/* To Date */}
                                    <div className="col-md-2">
                                        <label className="form-label fw-semibold">
                                            To Date
                                        </label>
                                        <input
                                            type="date"
                                            className="form-control form-control-sm"
                                            value={toDate}
                                            onChange={(e) =>
                                                setToDate(e.target.value)
                                            }
                                        />
                                    </div>
                                </div>

                                <hr className="my-3" />

                                <div className="d-flex justify-content-end gap-2">
                                    <button
                                        className="btn btn-primary btn-sm px-4"
                                        onClick={handleSearch}
                                    >
                                        Search
                                    </button>

                                    <button
                                        className="btn btn-outline-secondary btn-sm px-4"
                                        onClick={handleReset}
                                    >
                                        Reset
                                    </button>

                                </div>
                            </div>
                        </div>

                    </div>

                )
            }
            <div className="row mb-5"
                style={{
                    position: window.innerWidth >= 768 ? "sticky" : "static",
                    top: window.innerWidth >= 768 ? "250px" : "auto",
                    zIndex: window.innerWidth >= 768 ? 1000 : "auto",
                }}
            >

            </div>
            <div className="card shadow-sm border-0">
                <div className="card-header bg-primary text-white">
                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                        <h5 className="mb-0">
                            📄 Leave Applications
                        </h5>

                        <button
                            className="btn btn-success btn-sm"
                            onClick={handleApplyLeave}
                        >
                            Apply Leave
                        </button>
                    </div>
                </div>
                <div className="card-body p-0">
                    <div className="table-responsive">
                        <table className="table table-hovertable-bordered mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th>#</th>
                                    <th>Staff</th>
                                    <th>Category</th>
                                    <th>Reason</th>
                                    <th>From</th>
                                    <th>To</th>
                                    <th>Total Leave</th>
                                    <th>Status</th>
                                    {
                                        roleId == 1 && (
                                            <th>Action</th>
                                        )
                                    }

                                </tr>
                            </thead>
                            <tbody>
                                {filteredLeaveApplications.length > 0 ? (
                                    filteredLeaveApplications.map((application, index) => {
                                        const details = JSON.parse(application.details);

                                        return details.length > 0 ? (
                                            details.map((d, i) => (
                                                <tr key={`${index}-${i}`}>
                                                    {/* ✅ Only show once, spanning all rows */}
                                                    {i === 0 && (
                                                        <>
                                                            <td
                                                                rowSpan={details.length}
                                                                className="align-middle fw-bold"
                                                            >
                                                                {serial++}
                                                            </td>
                                                            <td
                                                                rowSpan={details.length}
                                                                className="align-middle"
                                                            >
                                                                {application.userName}
                                                            </td>
                                                        </>
                                                    )}

                                                    <td>
                                                        {
                                                            allLeaveCategories.find((a) => a.id == d.leaveCategoryId)?.category || "-"
                                                        }
                                                    </td>

                                                    <td>{d.reason}</td>
                                                    <td>{formatDate(d.fromDate)}</td>
                                                    <td>{formatDate(d.toDate)}</td>

                                                    {i === 0 && (
                                                        <>
                                                            <td
                                                                rowSpan={details.length}
                                                                className="align-middle text-center fw-bold text-success"
                                                            >
                                                                {application.totalLeaveApply}
                                                            </td>
                                                            <td
                                                                rowSpan={details.length}
                                                                className="align-middle"
                                                            >
                                                                {renderStatus(application.leaveStatus)}
                                                            </td>
                                                            {
                                                                roleId == 1 && (
                                                                    <td rowSpan={details.length} className="align-middle">
                                                                        <button
                                                                            className="btn btn-sm btn-primary me-1"
                                                                            onClick={() =>
                                                                                handleApprove(application.id, application.userId)
                                                                            }
                                                                            disabled={application.leaveStatus === 1}
                                                                        >
                                                                            Approve
                                                                        </button>
                                                                        <button
                                                                            className="btn btn-sm btn-danger"
                                                                            onClick={() =>
                                                                                handleCancel(application.id)
                                                                            }
                                                                            disabled={application.leaveStatus === 2}
                                                                        >
                                                                            Cancel
                                                                        </button>
                                                                    </td>
                                                                )
                                                            }

                                                        </>
                                                    )}
                                                </tr>
                                            ))
                                        ) : (
                                            <tr key={index}>
                                                <td>{serial++}</td>
                                                <td colSpan="7" className="text-center text-muted">
                                                    No details available
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="9" className="text-center py-4 text-muted">
                                            🚫 No Leave Applications Found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default LeaveApplicationList;
